import { type Address } from '@/types/Account';
import axios from 'axios';
import type { APIResponse } from '~/api/utils';
import type { CustomAxiosRequestConfig } from '~/plugins/axios';

const ACCOUNT_API_URL = `${import.meta.env.VITE_API_IDENTITY_URL}/account`;

class IdentityService {
    async createSubscription(email: string, recaptchaToken: string): Promise<any> {
        const response = await axios.post(
            `${import.meta.env.VITE_API_IDENTITY_URL}/subscription`,
            {
                email,
                recaptchaToken,
            },
            {
                suppressToast: true,
            } as CustomAxiosRequestConfig,
        );
        return response;
    }

    async getAccount(id: string) {
        const response = await axios.get(`${ACCOUNT_API_URL}/${id}`);
        return response.data;
    }

    async linkWallet(id: string, wallet: string) {
        const response = await axios.patch(
            `${ACCOUNT_API_URL}/${id}`,
            {
                wallet: wallet,
            },
            {
                suppressToast: true,
            } as CustomAxiosRequestConfig,
        );
        return response.data;
    }

    async invitedCount(id: string) {
        const response = await axios.get(`${ACCOUNT_API_URL}/${id}/invited-count`);
        return response.data;
    }

    async retriveAllAddresses(id: string): Promise<APIResponse<Address[]>> {
        const response = await axios.get(`${ACCOUNT_API_URL}/${id}/address`);
        return response.data;
    }

    async createAddress(id: string, data?: Address): Promise<APIResponse<Address>> {
        const response = await axios.post(`${ACCOUNT_API_URL}/${id}/address`, {
            ...data,
        });
        return response.data;
    }

    async updateAddress(id: string, data?: Address): Promise<APIResponse<Address>> {
        const response = await axios.post(`${ACCOUNT_API_URL}/${id}/address`, {
            data: {
                ...data,
            },
        });
        return response.data;
    }

    async deleteAddress(account: string, id: string): Promise<APIResponse<Address>> {
        const response = await axios.delete(`${ACCOUNT_API_URL}/${account}/address/${id}`);
        return response.data;
    }
}

export default new IdentityService();
